var render = function render(){
  var _vm$payload, _vm$payload2, _vm$payload3, _vm$payload4, _vm$payload5, _vm$$helper, _vm$payload6, _vm$payload7, _vm$payload8, _vm$payload9, _vm$payload10, _vm$payload11, _vm$payload11$equipme, _vm$payload12, _vm$payload12$brand, _vm$payload13, _vm$payload13$categor, _vm$payload14, _vm$payload15, _vm$payload16, _vm$payload17, _vm$payload18, _vm$payload19;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "row p6 radius6 animate-bottom"
  }, [_c('div', {
    staticClass: "form-container-wrapper"
  }, [_vm.isFetching ? _c('div', {
    staticClass: "container-wrap"
  }, [_vm._m(0)]) : _c('div', {
    staticClass: "container-wrap"
  }, [(_vm$payload = _vm.payload) !== null && _vm$payload !== void 0 && _vm$payload.id ? _c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "title-item"
  }, [_vm._v("Request Information")]), _c('div', {
    staticClass: "content-item"
  }, [_c('div', {
    staticClass: "content-item-card"
  }, [_vm._m(1), _c('div', {
    staticClass: "content-item-card-context"
  }, [_c('span', {
    staticStyle: {
      "min-width": "140px"
    }
  }, [_vm._v("Topic")]), _c('span', [_c('span', [_vm._v(":")]), _c('span', {
    staticClass: "ml10"
  }, [_vm._v(_vm._s(((_vm$payload2 = _vm.payload) === null || _vm$payload2 === void 0 ? void 0 : _vm$payload2.topicName) || ((_vm$payload3 = _vm.payload) === null || _vm$payload3 === void 0 ? void 0 : _vm$payload3.name) || ((_vm$payload4 = _vm.payload) === null || _vm$payload4 === void 0 ? void 0 : _vm$payload4.subject) || "N/A"))])])]), _c('div', {
    staticClass: "content-item-card-context"
  }, [_c('span', {
    staticStyle: {
      "min-width": "140px"
    }
  }, [_vm._v("Provider")]), _c('span', [_c('span', [_vm._v(":")]), _c('span', {
    staticClass: "ml10"
  }, [_vm._v(_vm._s(((_vm$payload5 = _vm.payload) === null || _vm$payload5 === void 0 ? void 0 : _vm$payload5.provider) || "Ecommerce"))])])]), _c('div', {
    staticClass: "content-item-card-context"
  }, [_c('span', {
    staticStyle: {
      "min-width": "140px"
    }
  }, [_vm._v("Created At")]), _c('span', [_c('span', [_vm._v(":")]), _c('span', {
    staticClass: "ml10"
  }, [_vm._v(_vm._s((_vm$$helper = _vm.$helper) === null || _vm$$helper === void 0 ? void 0 : _vm$$helper.formatDate((_vm$payload6 = _vm.payload) === null || _vm$payload6 === void 0 ? void 0 : _vm$payload6.createdAt)))])])]), _c('div', {
    staticClass: "content-item-card-context"
  }, [_c('span', {
    staticStyle: {
      "min-width": "140px"
    }
  }, [_vm._v("Status")]), _c('span', [_c('span', [_vm._v(":")]), _c('span', {
    staticClass: "ml10"
  }, [_c('span', {
    style: {
      color: '#27A832'
    }
  }, [_vm._v(" Success ")])])])]), _c('div', {
    staticClass: "content-item-card-context"
  }, [_c('span', {
    staticStyle: {
      "min-width": "140px"
    }
  }, [_vm._v("Training Info")]), _c('span', [_c('span', [_vm._v(":")]), _c('span', {
    staticClass: "ml10"
  }, [_vm._v(_vm._s(((_vm$payload7 = _vm.payload) === null || _vm$payload7 === void 0 ? void 0 : _vm$payload7.trainingInfo) || "N/A"))])])]), false ? _c('div', {
    staticClass: "content-item-card-context"
  }, [_c('span', {
    staticStyle: {
      "min-width": "140px"
    }
  }, [_vm._v("Remark")]), _c('span', [_c('span', [_vm._v(":")]), _c('span', {
    staticClass: "ml10"
  }, [_vm._v(_vm._s(((_vm$payload8 = _vm.payload) === null || _vm$payload8 === void 0 ? void 0 : _vm$payload8.remark) || "N/A"))])])]) : _vm._e(), false ? _c('div', {
    staticClass: "content-item-card-context"
  }, [_c('span', {
    staticStyle: {
      "min-width": "140px"
    }
  }, [_vm._v("Photo")]), _c('span', {
    staticStyle: {
      "display": "flex",
      "align-items": "flex-start"
    }
  }, [_c('span', [_vm._v(":")]), _c('span', {
    staticClass: "ml10"
  }, [_c('image-detail', {
    attrs: {
      "heightChange": '294px',
      "widthChange": '294px',
      "objectFit": 'cover',
      "radiusChange": '10px',
      "thumbnail": ((_vm$payload9 = _vm.payload) === null || _vm$payload9 === void 0 ? void 0 : _vm$payload9.attachment) && _vm.getFullImage((_vm$payload10 = _vm.payload) === null || _vm$payload10 === void 0 ? void 0 : _vm$payload10.attachment) || require('@/assets/images/noImage.jpg')
    }
  })], 1)])]) : _vm._e()]), _c('div', {
    staticClass: "content-item-card",
    staticStyle: {
      "border": "none",
      "gap": "30px"
    }
  }, [false ? _c('div', {
    staticClass: "content-item-card-wrapper"
  }, [_vm._m(2), _c('div', {
    staticClass: "content-item-card-context"
  }, [_c('span', {
    staticStyle: {
      "min-width": "140px"
    }
  }, [_vm._v("Name")]), _c('span', [_c('span', [_vm._v(":")]), _c('span', {
    staticClass: "ml10"
  }, [_vm._v(_vm._s(((_vm$payload11 = _vm.payload) === null || _vm$payload11 === void 0 ? void 0 : (_vm$payload11$equipme = _vm$payload11.equipmentInfo) === null || _vm$payload11$equipme === void 0 ? void 0 : _vm$payload11$equipme.itemName) || "N/A"))])])]), _c('div', {
    staticClass: "content-item-card-context"
  }, [_c('span', {
    staticStyle: {
      "min-width": "140px"
    }
  }, [_vm._v("Brand")]), _c('span', [_c('span', [_vm._v(":")]), _c('span', {
    staticClass: "ml10"
  }, [_vm._v(_vm._s(((_vm$payload12 = _vm.payload) === null || _vm$payload12 === void 0 ? void 0 : (_vm$payload12$brand = _vm$payload12.brand) === null || _vm$payload12$brand === void 0 ? void 0 : _vm$payload12$brand.name) || "N/A"))])])]), _c('div', {
    staticClass: "content-item-card-context"
  }, [_c('span', {
    staticStyle: {
      "min-width": "140px"
    }
  }, [_vm._v("Category")]), _c('span', [_c('span', [_vm._v(":")]), _c('span', {
    staticClass: "ml10"
  }, [_vm._v(_vm._s(((_vm$payload13 = _vm.payload) === null || _vm$payload13 === void 0 ? void 0 : (_vm$payload13$categor = _vm$payload13.category) === null || _vm$payload13$categor === void 0 ? void 0 : _vm$payload13$categor.name) || "N/A"))])])])]) : _vm._e(), _c('div', {
    staticClass: "content-item-card-wrapper"
  }, [_vm._m(3), _c('div', {
    staticClass: "content-item-card-context"
  }, [_c('span', {
    staticStyle: {
      "min-width": "140px"
    }
  }, [_vm._v("Name")]), _c('span', [_c('span', [_vm._v(":")]), _c('span', {
    staticClass: "ml10"
  }, [_vm._v(_vm._s(((_vm$payload14 = _vm.payload) === null || _vm$payload14 === void 0 ? void 0 : _vm$payload14.bpName) || ((_vm$payload15 = _vm.payload) === null || _vm$payload15 === void 0 ? void 0 : _vm$payload15.customerName) || "N/A"))])])]), _c('div', {
    staticClass: "content-item-card-context"
  }, [_c('span', {
    staticStyle: {
      "min-width": "140px"
    }
  }, [_vm._v("Email Address")]), _c('span', [_c('span', [_vm._v(":")]), _c('span', {
    staticClass: "ml10"
  }, [_vm._v(_vm._s(((_vm$payload16 = _vm.payload) === null || _vm$payload16 === void 0 ? void 0 : _vm$payload16.emailAddress) || "N/A"))])])]), _c('div', {
    staticClass: "content-item-card-context"
  }, [_c('span', {
    staticStyle: {
      "min-width": "140px"
    }
  }, [_vm._v("Phone Number")]), _c('span', [_c('span', [_vm._v(":")]), _c('span', {
    staticClass: "ml10"
  }, [_vm._v(" " + _vm._s(_vm.$helper.formatPhoneNumber((_vm$payload17 = _vm.payload) === null || _vm$payload17 === void 0 ? void 0 : _vm$payload17.contactPhoneNumber)) + " ")])])])]), false ? _c('div', {
    staticClass: "content-item-card-wrapper"
  }, [_vm._m(4), _c('div', {
    staticClass: "content-item-card-context"
  }, [_c('span', {
    staticStyle: {
      "min-width": "140px"
    }
  }, [_vm._v("Name")]), _c('span', [_c('span', [_vm._v(":")]), _c('span', {
    staticClass: "ml10"
  }, [_vm._v(_vm._s(((_vm$payload18 = _vm.payload) === null || _vm$payload18 === void 0 ? void 0 : _vm$payload18.addressName) || "N/A"))])])]), _c('div', {
    staticClass: "content-item-card-context"
  }, [_c('span', {
    staticStyle: {
      "min-width": "140px"
    }
  }, [_vm._v("Address")]), _c('span', [_c('span', [_vm._v(":")]), _c('span', {
    staticClass: "ml10"
  }, [_vm._v(_vm._s(((_vm$payload19 = _vm.payload) === null || _vm$payload19 === void 0 ? void 0 : _vm$payload19.addressDetail) || "N/A"))])])])]) : _vm._e()])])]) : _c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "title-item"
  }, [_vm._v("Request Information")]), _vm._m(5)]), _c('div', {
    staticClass: "form-footer",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('button', {
    staticClass: "btn btn-light-secondary",
    staticStyle: {
      "min-width": "130px"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v(" BAck ")])])])])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "form-item",
    staticStyle: {
      "min-height": "200px",
      "display": "flex",
      "align-items": "center",
      "justify-content": "center"
    }
  }, [_c('div', {
    staticClass: "loader-circle"
  })]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "content-item-card-header"
  }, [_c('span', [_vm._v("Request Detail")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "content-item-card-header"
  }, [_c('span', [_vm._v("Equipment")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "content-item-card-header"
  }, [_c('span', [_vm._v("Contact Information")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "content-item-card-header"
  }, [_c('span', [_vm._v("Location")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "content-item",
    staticStyle: {
      "height": "150px",
      "display": "flex",
      "align-items": "center",
      "justify-content": "center"
    }
  }, [_c('span', [_vm._v("Invalid Request")])]);

}]

export { render, staticRenderFns }